import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export class ApMortgageValidator {
    /**
     * Validation that checks if value is 9 or 10 digits and is a valid BBAN mortgage number
     */
    public static validate(control: AbstractControl): ValidationErrors {
        return Validators.compose([Validators.pattern(/^[0-9.\s]+$/i), ApMortgageValidator.validateMortgage])(control);
    }

    /**
     * Validate that control has a mortgage value
     */
    private static validateMortgage(control: AbstractControl): ValidationErrors {
        if (!control.value) {
            return null;
        }

        const numericValue = control.value.replace(/\D/g, '');
        if (numericValue.length !== 9 && numericValue.length !== 10) {
            return { mortgage: true };
        }

        const validElfProef = ApMortgageValidator.validElfProef(numericValue);
        return validElfProef ? null : { mortgage: true };
    }

    /**
     * Check if [elfproef](https://www.mobilefish.com/services/elfproef/elfproef.php#:~:text=Elfproef%20(Dutch%20for%20Eleven%20test,numbers%20have%20maximum%2010%20digits.)
     * is valid
     */
    private static validElfProef(value: string): boolean {
        const weights = value.length === 9 ? [9, 8, 7, 6, 5, 4, 3, 2, 1] : [10, 9, 8, 7, 6, 5, 4, 3, 2, 1];

        const numbers = value.split('');
        const sum = numbers
            .map((numVal: string, index: number) => {
                const number = parseInt(numVal, 10);
                const weight = weights[index];
                return number * weight;
            })
            .reduce((a, b) => a + b);
        return sum % 11 === 0;
    }
}
